var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.is_divided)?[_c('divided-task')]:[_c('index')],_c('error-box')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }